export default __webpack_public_path__ + "static/media/custom.ea055e41.png";